// extracted by mini-css-extract-plugin
module.exports = {"popupRow":"List_popupRow_1jupw","pagination":"List_pagination_3QHN_","paginationText":"List_paginationText_3chWU","paginationButton":"List_paginationButton_BaeNI"};